import { Briefcase } from './briefcase.model';

export class BriefcaseCollection {
	public items: Briefcase[];
	public totalItems: number;
}
